import { NgModule } from '@angular/core';

import { FeatureToggleModule } from 'ish-core/feature-toggle.module';
import { LAZY_FEATURE_MODULE } from 'ish-core/utils/module-loader/module-loader.service';

import { LazyMultipleShippingCheckoutButtonComponent } from './lazy-multiple-shipping-checkout-button/lazy-multiple-shipping-checkout-button.component';

@NgModule({
  imports: [FeatureToggleModule],
  providers: [
    {
      provide: LAZY_FEATURE_MODULE,
      useValue: {
        feature: 'multipleShippingCheckout',
        location: () =>
          import('../store/multiple-shipping-checkout-store.module').then(m => m.MultipleShippingCheckoutStoreModule),
      },
      multi: true,
    },
  ],
  declarations: [LazyMultipleShippingCheckoutButtonComponent],
  exports: [LazyMultipleShippingCheckoutButtonComponent],
})
export class MultipleShippingCheckoutExportsModule {}
